{
  "welcome": "Bienvenido a Harmonia",
  "landing": {
    "nav": {
      "brand": "Harmonia",
      "install": "Instalar",
      "cta": "Unirse"
    },
    "installHints": {
      "ios": {
        "title": "Instalar Harmonia",
        "step1": "1. Toca el ícono Compartir de Safari",
        "step2": "2. Elige «Añadir a pantalla de inicio»",
        "step3": "3. Confirma con «Añadir»",
        "close": "Entendido"
      },
      "firefox": {
        "title": "Instalar Harmonia",
        "step1": "1. Abre el menú (≡) de Firefox",
        "step2": "2. Elige «Instalar» o «Añadir a pantalla de inicio»",
        "step3": "3. Confirma la instalación",
        "close": "Entendido"
      },
      "generic": {
        "title": "Instalar Harmonia",
        "step1": "1. Abre el menú de tu navegador",
        "step2": "2. Busca «Instalar aplicación» o «Añadir a pantalla de inicio»",
        "step3": "3. Confirma la instalación",
        "close": "Entendido"
      }
    },
    "hero": {
      "pill": "Centro de Talentos",
      "titleLine1": "Revela",
      "titleLine2": "tu",
      "titleHighlight": "talento",
      "titleLine3": "al mundo",
      "sub": "La plataforma diseñada para inspirar, conectar e impulsar a creadores, gamers e innovadores.",
      "statDisciplines": "Disciplinas",
      "statConcours": "Concursos",
      "statTrophees": "Trofeos en vivo",
      "badgeTrophees": "Trofeos",
      "badgeLive": "En vivo",
      "badgeCommunaute": "Comunidad",
      "ctaMain": "Comenzar la aventura",
      "ctaInstall": "Instalar la app",
      "ctaSecondary": "Explorar el universo"
    },
    "market": {
  "chip": "SOLUCIÓN PRO",
  "titleLine1": "Tu tienda,",
  "titleLine2": "tu sitio, tu mundo",
  "sub": "Comerciantes, artesanos, emprendedores: crea tu tienda en Harmonia y obtén un verdadero sitio web, personalizable y accesible desde cualquier lugar del mundo, tanto en la plataforma como fuera de ella.",
  "feature1Title": "Sitio completo y personalizable",
  "feature1Desc": "Cada tienda se convierte en un sitio web completo, hecho a tu medida: diseño, presentación e identidad visual.",
  "feature2Title": "Un enlace URL para tu tienda",
  "feature2Desc": "Comparte tu tienda donde quieras mediante un enlace público funcional, sin que tus clientes necesiten una cuenta.",
  "feature3Title": "Un enlace URL por producto",
  "feature3Desc": "Cada producto tiene su propia página completa y su propio enlace, listo para compartir en todas tus redes sociales.",
  "feature4Title": "Presente en todas partes, vende en todas partes",
  "feature4Desc": "Publica, presenta tus productos y conecta con tus clientes en todas las plataformas, estén donde estén en el mundo.",
  "statBoutiques": "Tiendas activas",
  "statProduits": "Productos publicados",
  "statMonde": "Accesible en todo el mundo",
  "cta": "Crear mi tienda"
},
    "vision": {
      "chip": "NUESTRA VISIÓN",
      "titleLine1": "Una armonía",
      "titleLine2": "planetaria",
      "sub": "Creemos que el talento no tiene fronteras. Harmonia es el espacio donde tus ideas cobran vida, respaldadas por una energía colectiva sin precedentes.",
      "card1Title": "Creatividad libre",
      "card1Desc": "Un espacio acogedor diseñado para dar rienda suelta a tu imaginación, sin barreras.",
      "card2Title": "Conexiones fuertes",
      "card2Desc": "Conoce mentes apasionadas, colabora en proyectos inéditos y crece junto a otros.",
      "card3Title": "Evolución constante",
      "card3Desc": "Rodéate de una dinámica positiva que impulsa a cada persona a superarse cada día."
    },
    "disciplines": {
      "chip": "NUESTRAS DISCIPLINAS",
      "titleLine1": "Elige",
      "titleLine2": "tu escenario",
      "sub": "Concursos activos repartidos en varias disciplinas. Enfréntate a tus amigos, demuestra lo que sabes hacer — y gana trofeos entregados públicamente ante toda la comunidad. Cada semana, nuevos desafíos.",
      "statDisciplines": "Disciplinas",
      "statConcours": "Concursos",
      "statHebdo": "Semanal",
      "trophyBanner": "Tu talento merece ser visto · Tu victoria merece ser celebrada",
      "hint": "Toca una disciplina para empezar",
      "ctaTrophies": "Trofeos · Entregados públicamente",
      "strategie": {
        "label": "Juegos de Estrategia",
        "tagline": "Pura reflexión y táctica",
        "desc": "Enfréntate a tus rivales en intensos duelos de estrategia. Cada victoria te acerca al podio.",
        "item1Name": "Awalé",
        "item1Sub": "El arte ancestral de la estrategia",
        "item2Name": "Damas",
        "item2Sub": "Domina el tablero"
      },
      "connaissance": {
        "label": "Conocimientos",
        "tagline": "Pon a prueba tu saber",
        "desc": "Duelos intelectuales tan emocionantes como impredecibles. El conocimiento en la cima merece su corona.",
        "item1Name": "Verdadero o Falso",
        "item1Sub": "Desafía a tus amigos con datos"
      },
      "arts": {
        "label": "Artes",
        "tagline": "Creatividad y expresión",
        "desc": "Tu mirada, tu trazo, tu estilo. Muestra tus creaciones y recibe el reconocimiento que merecen.",
        "item1Name": "Fotografía",
        "item1Sub": "Tu mirada, tu firma",
        "item2Name": "Dibujo",
        "item2Sub": "Tu trazo, tu universo",
        "item3Name": "Diseño",
        "item3Sub": "La estética al servicio de la intención"
      },
      "performance": {
        "label": "Performance",
        "tagline": "Sube al escenario",
        "desc": "Encarna, cautiva, trasciende. El escenario de Harmonia espera tu consagración.",
        "item1Name": "Comedia",
        "item1Sub": "La risa, el arte más universal",
        "item2Name": "Danza",
        "item2Sub": "Cada movimiento cuenta una historia",
        "item3Name": "Teatro",
        "item3Sub": "Encarna, cautiva, trasciende"
      },
      "musique": {
        "label": "Música",
        "tagline": "Haz vibrar el escenario",
        "desc": "Tu voz, tus instrumentos, tu huella en el mundo. Las grandes voces merecen su ovación.",
        "item1Name": "Canto",
        "item1Sub": "Tu voz, tu instrumento más preciado",
        "item2Name": "Piano",
        "item2Sub": "88 teclas, un universo infinito",
        "item3Name": "Guitarra",
        "item3Sub": "Cada acorde, una declaración"
      },
      "artisanat": {
        "label": "Artesanía",
        "tagline": "Excelencia en el oficio",
        "desc": "Oficios nobles, maestría poco común. La excelencia artesanal merece su podio y reconocimiento.",
        "item1Name": "Costura",
        "item1Sub": "El arte que viste al mundo",
        "item2Name": "Carpintería",
        "item2Sub": "La madera en tus manos se vuelve obra",
        "item3Name": "Peluquería",
        "item3Sub": "Sublimar, transformar, revelar",
        "item4Name": "Soldadura",
        "item4Sub": "La precisión que une los metales",
        "item5Name": "Mecánica",
        "item5Sub": "La ciencia que hace girar el mundo"
      }
    },
    "challenge": {
      "chip": "DESAFÍOS Y CONCURSOS",
      "title": "Concursos para hacerte brillar",
      "sub": "Cada disciplina abre la puerta a concursos semanales. Estrategia, artes, música, performance, artesanía — tu área de excelencia seguro tiene su competencia en Harmonia.",
      "subMobile": "Cada disciplina abre la puerta a concursos semanales. Tu área de excelencia tiene su competencia en Harmonia.",
      "cta": "Aceptar un desafío"
    },
    "community": {
      "chip": "COMUNIDAD",
      "titleLine1": "Una familia",
      "titleLine2": "inspiradora",
      "sub": "Únete a un mosaico de talentos. Ya sea para compartir una obra, encontrar inspiración o construir el futuro, aquí encontrarás tu lugar.",
      "cta": "Unirse a la comunidad"
    },
    "final": {
      "titleLine1": "Tu momento",
      "titleLine2": "ha llegado",
      "sub": "No dejes esperando tu potencial ni un momento más.\nHaz que tu voz resuene hoy mismo.",
      "cta": "Crear mi perfil creativo",
      "note": "La aventura comienza aquí · Acceso inmediato · Gratis"
    },
    "footer": {
      "tagline": "Cultivemos la inspiración, juntos.",
      "copyright": "Todos los derechos reservados"
    }
  },
  "login": {
    "common": {
      "tagline": "Revela Tu Talento",
      "or": "o",
      "continueWithGoogle": "Continuar con Google",
      "needHelp": "¿Necesitas ayuda?",
      "loading": "Cargando...",
      "emailPlaceholder": "Email",
      "passwordPlaceholder": "Contraseña"
    },
    "login": {
      "title": "Iniciar sesión",
      "subtitle": "¡Bienvenido! Inicia sesión para continuar",
      "forgotPassword": "¿Olvidaste tu contraseña?",
      "submit": "Iniciar sesión",
      "noAccountPrefix": "¿Aún no te registraste?",
      "noAccountLink": "Crear una cuenta"
    },
    "signup": {
      "title": "Registro",
      "subtitle": "Crea tu cuenta de Harmonia",
      "lastNamePlaceholder": "Apellido",
      "firstNamePlaceholder": "Nombre",
      "passwordPlaceholder": "Contraseña (mín. 6 caracteres)",
      "submit": "Crear mi cuenta",
      "alreadyAccountPrefix": "¿Ya tienes una cuenta?",
      "alreadyAccountLink": "Iniciar sesión"
    },
    "verify": {
      "title": "Verifica tu email",
      "subtitle": "Se ha enviado un enlace de confirmación a",
      "step1": "Consulta tu bandeja de entrada",
      "step2": "Haz clic en el enlace de confirmación",
      "step3": "Vuelve aquí y haz clic en \"Verificar\"",
      "submit": "Verificar activación",
      "backToSignup": "Volver al registro"
    },
    "reset": {
      "title": "Contraseña olvidada",
      "subtitle": "Ingresa tu email para recibir un enlace de restablecimiento",
      "submit": "Enviar enlace",
      "backToLogin": "Volver al inicio de sesión",
      "confirm": {
        "checkingLink": "Verificando el enlace...",
        "title": "Nueva contraseña",
        "subtitle": "Elige una nueva contraseña segura para tu cuenta.",
        "newPasswordPlaceholder": "Nueva contraseña",
        "confirmPasswordPlaceholder": "Confirmar contraseña",
        "submit": "Restablecer mi contraseña",
        "backToLogin": "Volver al inicio de sesión",
        "backToLoginArrow": "← Volver al inicio de sesión",
        "invalidLink": {
          "title": "Enlace inválido",
          "subtitle": "Este enlace es inválido o ha expirado.\nPor favor, vuelve a solicitar un restablecimiento de contraseña."
        },
        "messages": {
          "fillBothFields": "Por favor completa ambos campos",
          "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
          "passwordsDoNotMatch": "Las contraseñas no coinciden",
          "resetting": "Restableciendo...",
          "resetError": "Error al restablecer la contraseña",
          "passwordChanged": "¡Contraseña modificada con éxito!",
          "cannotResetPassword": "No se pudo restablecer la contraseña"
        }
      }
    },
    "confirmGoogle": {
      "title": "Confirmar identidad",
      "subtitle": "Continuar como",
      "submit": "Continuar",
      "cancel": "Cancelar"
    },
    "terms": {
      "prefix": "He leído y acepto los ",
      "cgu": "Términos de uso",
      "middle": ", la ",
      "privacy": "Política de privacidad",
      "and": " y las ",
      "community": "Normas de la comunidad"
    },
    "google": {
      "defaultUser": "Usuario"
    },
    "messages": {
      "mustAcceptTerms": "Debes aceptar los términos de uso para continuar",
      "fillAllFields": "Por favor completa todos los campos",
      "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
      "invalidDate": "Formato de fecha inválido",
      "registrationsClosed": "Las inscripciones están cerradas actualmente.",
      "cannotVerifyRegistrations": "No se pueden verificar las inscripciones.",
      "cannotReachServer": "No se pudo contactar al servidor.",
      "creatingAccount": "Creando cuenta...",
      "signupError": "Error durante el registro",
      "accountCreated": "¡Cuenta creada! Verifica tu email.",
      "cannotCreateAccount": "No se pudo crear la cuenta",
      "verifying": "Verificando...",
      "verificationError": "Error de verificación",
      "emailVerified": "¡Email verificado! ¡Bienvenido a Harmonia!",
      "emailNotVerified": "Email no verificado. Haz clic en el enlace de tu correo.",
      "cannotVerifyEmail": "No se pudo verificar el email",
      "enterEmailPassword": "Por favor ingresa tu email y contraseña",
      "loggingIn": "Iniciando sesión...",
      "emailNotConfirmed": "Email no confirmado. Revisa tu bandeja de entrada.",
      "incorrectCredentials": "Credenciales incorrectas",
      "loginSuccess": "¡Sesión iniciada con éxito! ¡Bienvenido!",
      "cannotLogin": "No se pudo iniciar sesión",
      "enterEmail": "Por favor ingresa tu email",
      "sendingEmail": "Enviando email...",
      "noAccountWithEmail": "No hay ninguna cuenta con este email",
      "resetRequestError": "Error al procesar la solicitud",
      "linkSent": "¡Enlace enviado! Consulta tu bandeja de entrada.",
      "cannotSendEmail": "No se pudo enviar el email",
      "googleWebFailed": "Falló el inicio de sesión de Google en la web",
      "googleTokenMissing": "Falta el token de autenticación de Google",
      "googleCancelled": "Inicio de sesión de Google cancelado",
      "googleFailed": "No se pudo completar el inicio de sesión de Google",
      "googleInProgress": "El inicio de sesión de Google ya está en curso",
      "playServicesUnavailable": "Los servicios de Google Play no están disponibles",
      "googleError": "Error durante el inicio de sesión de Google",
      "certifyingIdentity": "Certificando tu identidad...",
      "googleServerValidationFailed": "Falló la validación de Google en el servidor",
      "welcomeUser": "¡Bienvenido, {{name}}!",
      "googleFinalizeError": "No se pudo finalizar el inicio de sesión de Google"
    }
  },
  "guide": {
    "header": {
      "title": "Guía de uso",
      "gotIt": "¡Entendido!"
    },
    "guides": {
      "create": {
        "tabLabel": "Crear",
        "title": "Crear mi cuenta Harmonia",
        "step1": "Toca «Crear una cuenta» en la parte inferior de la pantalla de inicio de sesión.",
        "step2": "Ingresa tu apellido, nombre y fecha de nacimiento.",
        "step3": "Ingresa una dirección de email válida.",
        "step4": "Elige una contraseña de al menos 6 caracteres.",
        "step5": "Marca la casilla para aceptar los Términos de uso, la Política de privacidad y las Normas de la comunidad.",
        "step6": "El botón «Crear mi cuenta» se activa — tócalo.",
        "step7": "Revisa tu bandeja de entrada y haz clic en el enlace de confirmación recibido.",
        "step8": "Vuelve a la app y toca «Verificar activación» para finalizar."
      },
      "login": {
        "tabLabel": "Iniciar sesión",
        "title": "Iniciar sesión en Harmonia",
        "step1": "Ingresa tu dirección de email en el primer campo.",
        "step2": "Ingresa tu contraseña en el segundo campo.",
        "step3": "Usa el ícono 👁 para mostrar u ocultar tu contraseña.",
        "step4": "Toca el botón «Iniciar sesión».",
        "step5": "¡Serás redirigido a tu espacio Harmonia!"
      },
      "reset": {
        "tabLabel": "Contraseña olvidada",
        "title": "Contraseña olvidada",
        "step1": "En la pantalla de inicio de sesión, toca «¿Olvidaste tu contraseña?».",
        "step2": "Ingresa la dirección de email vinculada a tu cuenta Harmonia.",
        "step3": "Toca «Enviar enlace».",
        "step4": "Revisa tu bandeja de entrada (¡verifica también el spam!).",
        "step5": "Haz clic en el enlace de restablecimiento recibido por email.",
        "step6": "Define tu nueva contraseña y luego inicia sesión.",
        "note": "⏱ El enlace expira rápidamente. ¡Actúa en cuanto recibas el email!"
      },
      "google": {
        "tabLabel": "Google",
        "title": "Iniciar sesión con Google",
        "step1": "Toca «Continuar con Google» en la pantalla de inicio de sesión o registro.",
        "step2": "Selecciona tu cuenta de Google en la ventana que se abre.",
        "step3": "Verifica la información mostrada y luego toca «Continuar».",
        "step4": "¡Has iniciado sesión en Harmonia!",
        "note": "💡 Para registrarte con Google, marca primero los Términos de uso antes de tocar el botón de Google."
      },
      "verify": {
        "tabLabel": "Email",
        "title": "Verificación del email",
        "step1": "Después de registrarte, se te envía automáticamente un email de confirmación.",
        "step2": "Abre tu bandeja de entrada y revisa también el spam / correo no deseado.",
        "step3": "Haz clic en el botón «Confirmar mi email» en el correo recibido.",
        "step4": "Vuelve a la aplicación Harmonia.",
        "step5": "Toca «Verificar activación» para finalizar tu registro.",
        "note": "⚠️ El enlace es válido por 24 horas. Si expiró, vuelve a comenzar el registro desde el principio."
      }
    }
  },
  "notifications": {
    "header": {
      "subtitle": "Centro de notificaciones"
    },
    "tabs": {
      "notifs": "Notificaciones",
      "last24h": "Info 24h",
      "trophees": "Trofeos"
    },
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "{{count}} min",
      "minutes_other": "{{count}} min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "types": {
      "friendRequest": "Solicitud de amistad",
      "friendAccepted": "Amistad aceptada",
      "like": "Me gusta",
      "comment": "Comentario",
      "report": "Reporte",
      "postStatus": "Estado",
      "default": "Anuncio"
    },
    "error": {
      "notConnected": "No conectado",
      "generic": "Error {{status}}",
      "retry": "Reintentar"
    },
    "loading": {
      "default": "Cargando…",
      "info24h": "Cargando…",
      "info24hFull": "Cargando las últimas 24 horas…"
    },
    "markAll": {
      "action": "Marcar todo como leído"
    },
    "empty": {
      "notifs": {
        "title": "Sin notificaciones",
        "sub": "Aquí se te informará de la actividad."
      },
      "last24h": {
        "title": "Sin actividad reciente",
        "sub": "No se registraron notificaciones en las últimas 24 horas."
      },
      "trophees": {
        "title": "Sin trofeos",
        "sub": "¡Participa en las sesiones para ganar algunos!"
      }
    },
    "more": {
      "loadOlder": "Cargar anteriores"
    },
    "end": {
      "upToDate": "Estás al día"
    },
    "info24h": {
      "title": "Actividad de las últimas 24h",
      "count_one": "{{count}} notificación reciente",
      "count_other": "{{count}} notificaciones recientes",
      "unread_one": "{{count}} sin leer",
      "unread_other": "{{count}} sin leer"
    },
    "card": {
      "grouped_one": "{{count}} evento agrupado",
      "grouped_other": "{{count}} eventos agrupados"
    },
    "trophy": {
      "won_one": "trofeo conseguido",
      "won_other": "trofeos conseguidos",
      "awardedBy": "Otorgado por {{firstName}} {{lastName}}"
    }
  },
  "editPostModal": {
    "errors": {
      "sessionNotFound": "Sesión no encontrada",
      "accessTokenMissing": "Falta access_token"
    },
    "deleteConfirm": {
      "title": "¿Eliminar la publicación?",
      "text": "Esta acción es irreversible. La publicación se eliminará permanentemente.",
      "cancel": "Cancelar",
      "confirm": "Eliminar"
    },
    "menu": {
      "title": "Opciones de la publicación",
      "edit": "Editar",
      "delete": "Eliminar",
      "cancel": "Cancelar"
    },
    "edit": {
      "title": "Editar publicación",
      "placeholder": "¿Qué hay de nuevo?",
      "save": "Guardar"
    }
  },
  "logoutModal": {
    "errors": {
      "sessionNotFound": "Sesión no encontrada"
    },
    "memory": {
      "title": "¿Recordar esta cuenta?",
      "message": "¿Deseas recordar esta cuenta para iniciar sesión más rápido la próxima vez, sin volver a escribir tu contraseña?",
      "no": "No",
      "yes": "Sí"
    },
    "confirm": {
      "title": "¿Cerrar sesión?",
      "message": "¿Estás seguro de que quieres cerrar sesión en tu cuenta?",
      "cancel": "Cancelar",
      "submit": "Cerrar sesión"
    }
  },
  "commentsModal": {
    "errors": {
      "sessionNotFound": "Sesión no encontrada",
      "accessTokenMissing": "Falta access_token",
      "sendError": "Error al enviar",
      "title": "Error",
      "networkError": "Error de red, inténtalo de nuevo",
      "networkErrorTitle": "Error de red",
      "tryAgain": "Por favor, inténtalo de nuevo"
    },
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "hace {{count}}min",
      "minutes_other": "hace {{count}}min",
      "hours_one": "hace {{count}}h",
      "hours_other": "hace {{count}}h",
      "days_one": "hace {{count}}d",
      "days_other": "hace {{count}}d"
    },
    "likesCount_one": "{{count}} me gusta",
    "likesCount_other": "{{count}} me gusta",
    "liked": "Te gusta",
    "like": "Me gusta",
    "reply": "Responder",
    "header": {
      "title": "Comentarios"
    },
    "empty": {
      "title": "Sin comentarios",
      "subtitle": "¡Sé el primero en comentar!"
    },
    "replyingTo": "Respondiendo a {{name}}",
    "replyPlaceholder": "Responder a {{name}}...",
    "addPlaceholder": "Agregar un comentario..."
  },
  "groupsTab": {
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "loadingData": "Cargando datos",
    "tabs": {
      "mine_one": "Mis grupos ({{count}})",
      "mine_other": "Mis grupos ({{count}})",
      "explore": "Explorar"
    },
    "empty": {
      "noResults": "Sin resultados",
      "noResultsFor": "Sin grupos para «{{query}}»",
      "noGroups": "No estás en ningún grupo",
      "exploreCta": "Explorar grupos",
      "noGroupsAvailable": "No hay grupos disponibles"
    },
    "lastMessage": "{{sender}}: {{content}}",
    "memberCount_one": "{{count}} miembro",
    "memberCount_other": "{{count}} miembros",
    "you": "Tú",
    "open": "Abrir",
    "join": "Unirse",
    "joining": "..."
  },
  "infoBanner": {
    "previous": "Anterior",
    "next": "Siguiente",
    "closeAndResume": "Cerrar y reanudar",
    "news": "Noticia",
    "reduceAndResume": "Minimizar y reanudar la lectura"
  },
  "pushPromptModal": {
    "title": "¡Mantente informado!",
    "subtitle": "Recibe los anuncios importantes, tus trofeos y las nuevas sesiones de Harmonia directamente en tu dispositivo.",
    "icons": {
      "trophies": "Trofeos",
      "announcements": "Anuncios",
      "sessions": "Sesiones"
    },
    "enableButton": "Activar notificaciones",
    "dismissButton": "Ignorar ({{count}}s)"
  },
  "savedPostsModal": {
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "hace {{count}}min",
      "minutes_other": "hace {{count}}min",
      "hours_one": "hace {{count}}h",
      "hours_other": "hace {{count}}h",
      "days_one": "hace {{count}}d",
      "days_other": "hace {{count}}d"
    },
    "header": {
      "title": "Publicaciones guardadas"
    },
    "syncing": "Sincronizando…",
    "tapToPlay": "Toca para reproducir",
    "commentsCount_one": "{{count}} comentario",
    "commentsCount_other": "{{count}} comentarios",
    "sharesCount_one": "{{count}} compartido",
    "sharesCount_other": "{{count}} compartidos",
    "empty": {
      "title": "Sin publicaciones guardadas",
      "subtitle": "Las publicaciones que guardes aparecerán aquí"
    }
  },
  "sharersModal": {
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "hace {{count}}min",
      "minutes_other": "hace {{count}}min",
      "hours_one": "hace {{count}}h",
      "hours_other": "hace {{count}}h",
      "days_one": "hace {{count}}d",
      "days_other": "hace {{count}}d"
    },
    "errors": {
      "sessionExpired": "Sesión expirada",
      "loadFailed": "No se pudieron cargar los compartidos"
    },
    "sharedAt": "Compartido {{time}}",
    "header": {
      "title": "Compartidos",
      "titleWithCount": "Compartidos ({{count}})"
    },
    "loading": "Cargando...",
    "retry": "Reintentar",
    "empty": "Aún no hay compartidos"
  },
  "searchModal": {
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "hace {{count}}min",
      "minutes_other": "hace {{count}}min",
      "hours_one": "hace {{count}}h",
      "hours_other": "hace {{count}}h",
      "days_one": "hace {{count}}d",
      "days_other": "hace {{count}}d"
    },
    "categories": {
      "all": "Todo",
      "posts": "Publicaciones",
      "images": "Imágenes",
      "videos": "Videos",
      "music": "Música",
      "artisanat": "Artesanía"
    },
    "tapToPlay": "Toca para reproducir",
    "commentsCount_one": "{{count}} comentario",
    "commentsCount_other": "{{count}} comentarios",
    "sharesCount_one": "{{count}} compartido",
    "sharesCount_other": "{{count}} compartidos",
    "status": {
      "submissions": "Envíos",
      "votingOpen": "Votación abierta",
      "finished": "Finalizado"
    },
    "media": {
      "image": "imagen",
      "track": "pista",
      "video": "video",
      "hide": "Ocultar",
      "viewCount_one": "Ver {{count}} {{label}}",
      "viewCount_other": "Ver {{count}} {{label}}s"
    },
    "runNumber": "Run #{{number}}",
    "voted": "Votado",
    "vote": "Votar",
    "votesCount_one": "{{count}} voto",
    "votesCount_other": "{{count}} votos",
    "header": {
      "title": "Buscar"
    },
    "placeholder": "Palabras clave, descripciones, títulos…",
    "searchButton": "Buscar",
    "searching": "Buscando…",
    "noResults": {
      "title": "Sin resultados",
      "subtitle": "Prueba con otras palabras clave"
    },
    "resultsCount_one": "{{count}} resultado",
    "resultsCount_other": "{{count}} resultados",
    "intro": {
      "title": "Buscar en Harmonia",
      "subtitle": "Publicaciones, videos, imágenes, sonidos…\nElige una categoría y escribe tus palabras clave"
    }
  },
  "userProfileView": {
    "time": {
      "now": "Ahora mismo",
      "minutes_one": "hace {{count}}min",
      "minutes_other": "hace {{count}}min",
      "hours_one": "hace {{count}}h",
      "hours_other": "hace {{count}}h",
      "days_one": "hace {{count}}d",
      "days_other": "hace {{count}}d"
    },
    "tapToPlay": "Toca para reproducir",
    "commentsCount_one": "{{count}} comentario",
    "commentsCount_other": "{{count}} comentarios",
    "sharesCount_one": "{{count}} compartido",
    "sharesCount_other": "{{count}} compartidos",
    "loading": "Cargando...",
    "profileNotFound": "Perfil no encontrado",
    "retry": "Reintentar",
    "memberSince": "Miembro desde {{date}}",
    "friendsLabel": "Amigos",
    "trophiesLabel": "Trofeos",
    "friend": {
      "add": "Agregar amigo",
      "pending": "Pendiente",
      "accept": "Aceptar",
      "remove": "Quitar amigo"
    },
    "viewPosts": "Ver publicaciones",
    "postsCount": "Publicaciones ({{count}})",
    "noPosts": "Sin publicaciones",
    "notFriend": {
      "pendingSent": "Solicitud enviada — Esperando confirmación",
      "pendingReceived": "Acepta la solicitud para ver las publicaciones",
      "none": "Agrega a este usuario como amigo para ver sus publicaciones"
    }
  },
  "cgu": {
    "title": "Términos y Condiciones de Uso",
    "stats": {
      "sections": "Secciones",
      "law": "Derecho beninés",
      "compliant": "Conforme"
    },
    "sections": {
      "presentation": {
        "title": "Presentación de la plataforma",
        "p1": "Harmonia es una plataforma social mundial, disponible en la web y en móvil, que permite a sus miembros crear un perfil, publicar contenido, interactuar mediante la mensajería y los grupos, participar en concursos de talento, jugar juegos de cultura general y estrategia, y crear una tienda en línea para los usuarios PRO.",
        "p2": "Harmonia es desarrollada y operada por una entidad registrada en Benín.",
        "highlight1": "Al acceder a la plataforma y crear una cuenta, aceptas sin reservas estos Términos de Uso."
      },
      "inscription": {
        "title": "Acceso y registro",
        "sub1": "Creación de cuenta",
        "p1": "El acceso a las funcionalidades de Harmonia requiere la creación de una cuenta. El registro está abierto a cualquier persona en el mundo, sin restricción de edad.",
        "bullets1": [
          "Registro directo: apellido, nombre, dirección de correo y fecha de nacimiento",
          "Mediante proveedor externo (Google, Facebook, etc.): apellido, nombre y dirección de correo. La fecha de nacimiento puede completarse posteriormente."
        ],
        "sub2": "Exactitud de la información",
        "p2": "Te comprometes a proporcionar información exacta y actualizada al registrarte. Harmonia no podrá ser considerada responsable de las consecuencias derivadas de información inexacta.",
        "sub3": "Permanecer conectado",
        "highlight1": "Puedes elegir permanecer conectado a tu cuenta sin volver a ingresar tu contraseña cada vez que abras la aplicación. Esta elección te pertenece exclusivamente y puede modificarse en cualquier momento.",
        "sub4": "Menores de edad",
        "highlight2": "Para cualquier suscripción a un servicio de pago (suscripción, concurso de pago, tienda pro), un usuario menor de edad debe obtener el consentimiento explícito de su padre, madre o tutor legal antes de cualquier compra."
      },
      "publications": {
        "title": "Publicaciones y contenido",
        "sub1": "Límite diario",
        "bullets1": [
          "Usuarios estándar: 1 publicación por día",
          "Usuarios PRO: 3 publicaciones por día"
        ],
        "p1": "Este límite fomenta la calidad y relevancia de los contenidos compartidos en la plataforma.",
        "sub2": "Niveles de visibilidad",
        "bullets2": [
          "PRO — visible para toda la comunidad Harmonia (función de pago)",
          "Amigos — visible solo para tus amigos",
          "Amigos de amigos — visible para tus amigos y los amigos de estos",
          "Privado — visible solo para ti"
        ],
        "sub3": "Contenido prohibido",
        "bullets3": [
          "Contenido sexual explícito o desnudez",
          "Contenido de odio, discriminatorio o que incite a la violencia",
          "Información falsa deliberada y malintencionada",
          "Vulneración de los derechos de propiedad intelectual de un tercero",
          "Contenido ilegal según las leyes aplicables"
        ],
        "sub4": "Propiedad intelectual",
        "highlight1": "Conservas la propiedad total de tus contenidos. Harmonia no reclama ningún derecho sobre tus creaciones y nunca las utilizará con fines promocionales sin tu consentimiento.",
        "sub5": "Responsabilidad",
        "p2": "Cada usuario es el único y total responsable de los contenidos que publica. Harmonia se exime de toda responsabilidad por los contenidos publicados por sus miembros."
      },
      "abonnements": {
        "title": "Suscripciones y pagos",
        "sub1": "Funciones de pago",
        "bullets1": [
          "Visibilidad PRO: difundir una publicación a toda la comunidad",
          "Creación de una tienda pro y publicación de productos asociados",
          "Consumo de datos con fines personales",
          "Participación en concursos de pago"
        ],
        "sub2": "Medios de pago",
        "p1": "Harmonia acepta varios medios de pago: pago móvil, tarjeta bancaria y otros medios integrados progresivamente.",
        "sub3": "Política de no reembolso",
        "highlight1": "Toda compra es definitiva. Una vez que un servicio ha sido otorgado y utilizado, no se realizará ningún reembolso, incluso en caso de suspensión del contenido, de la tienda pro o de un producto por incumplimiento de las normas."
      },
      "messagerie": {
        "title": "Mensajería e interacciones",
        "sub1": "Mensajería privada",
        "p1": "La mensajería privada es estrictamente confidencial y accesible únicamente para los participantes de cada conversación.",
        "sub2": "Grupos de discusión",
        "p2": "Harmonia pone a disposición grupos de discusión comunitarios. Dentro de estos grupos, los usuarios también pueden escribirse en privado.",
        "highlight1": "Las normas de respeto y cortesía también se aplican en la mensajería privada."
      },
      "publicite": {
        "title": "Publicidad",
        "p1": "Al usar Harmonia, aceptas recibir publicaciones publicitarias integradas en la plataforma.",
        "highlight1": "Estos anuncios provienen exclusivamente de usuarios que se han suscrito a un plan publicitario de Harmonia. No se utiliza ninguna red publicitaria externa."
      },
      "concours": {
        "title": "Concursos de talento",
        "sub1": "Ámbitos cubiertos",
        "bullets1": [
          "Artes visuales: dibujo, fotografía",
          "Artes escénicas: comedia, danza",
          "Música: piano y otros instrumentos",
          "Oficios: actividades artesanales y profesiones",
          "Juegos de estrategia: damas, Awalé y otros",
          "Cultura general: Verdadero o Falso y otros formatos"
        ],
        "highlight1": "Harmonia no ofrece ningún juego de azar. El objetivo exclusivo es recompensar el talento real.",
        "sub2": "Sistema de votación",
        "p1": "El paso a la etapa presencial se determina por los votos de la comunidad. El voto es gratuito, abierto a todos los usuarios autenticados, y limitado a un solo voto por candidato.",
        "sub3": "Etapa presencial final",
        "p2": "Las finales pueden celebrarse en cualquier parte del mundo. Los países anfitriones y los jurados expertos son seleccionados aleatoriamente por Harmonia para garantizar la equidad. Las recompensas incluyen trofeos, premios en efectivo, regalos y otras distinciones anunciadas para cada concurso.",
        "sub4": "Información en tiempo real",
        "highlight2": "Todos los usuarios reciben información en tiempo real sobre el desarrollo de los concursos y la actividad de la plataforma, para que todos estén informados de manera equitativa."
      },
      "boutiques": {
        "title": "Tiendas pro",
        "sub1": "Descripción del servicio",
        "p1": "Los usuarios PRO pueden crear una tienda en la plataforma, accesible desde Harmonia y mediante un enlace URL público funcional en la web. Pueden personalizar el diseño y numerosos ajustes del sitio asociado a su tienda.",
        "highlight1": "Cada producto publicado en una tienda también tiene su propio enlace web que permite su consulta directa.",
        "sub2": "Propiedad y responsabilidad",
        "p2": "El usuario PRO conserva la propiedad del contenido de su tienda y es el único y total responsable de este, incluso frente a las personas que consulten sus enlaces web fuera de Harmonia.",
        "sub3": "Cumplimiento y suspensión",
        "p3": "El contenido de la tienda y de los productos está sujeto a las mismas normas que el resto de la plataforma (contenido prohibido, normas comunitarias). Harmonia puede suspender una tienda, un producto o desactivar un enlace web en caso de incumplimiento, sin derecho a reembolso."
      },
      "moderation": {
        "title": "Moderación y denuncia",
        "sub1": "Denuncia",
        "p1": "Cualquier usuario puede denunciar un contenido contrario a las normas, incluido el contenido de una tienda pro o de un producto publicado. Cuando un contenido recibe un número significativo de denuncias, pasa automáticamente a estado de revisión y deja de ser visible públicamente.",
        "sub2": "Decisión de los administradores",
        "bullets1": [
          "Contenido conforme: recupera su visibilidad normal",
          "Contenido no conforme: se suspende de forma definitiva y sin posibilidad de apelación"
        ],
        "highlight1": "Harmonia no procede a la expulsión de usuarios. Las medidas de moderación afectan a los contenidos, no a las personas."
      },
      "api": {
        "title": "Protección de la API y de los sistemas",
        "p1": "La API backend de Harmonia y el conjunto de sus sistemas técnicos son propiedad exclusiva de la plataforma. El acceso a la API está estrictamente reservado a las aplicaciones oficiales de Harmonia.",
        "sub1": "Actos prohibidos",
        "bullets1": [
          "Acceder a la API fuera de las aplicaciones oficiales",
          "Eludir los mecanismos de autenticación o de seguridad",
          "Interceptar los intercambios entre las aplicaciones y los servidores",
          "Utilizar robots, scripts automatizados o herramientas de scraping",
          "Realizar ataques DDoS o cualquier acción que perturbe la plataforma",
          "Explotar fallos técnicos con fines maliciosos",
          "Reproducir o redistribuir datos procedentes de la plataforma"
        ],
        "sub2": "Acciones judiciales",
        "highlight1": "Toda violación constituye una infracción grave susceptible de acciones judiciales. Harmonia cooperará con las autoridades competentes de cualquier país para identificar y perseguir a los infractores.",
        "sub3": "Notificación responsable",
        "p2": "Si descubres una brecha de seguridad, notifícala inmediatamente a harmonia@harmoniaworld.world sin explotarla. Harmonia tratará toda notificación de buena fe de manera seria y confidencial."
      },
      "disponibilite": {
        "title": "Disponibilidad de la plataforma",
        "p1": "Harmonia se esfuerza por garantizar una disponibilidad óptima. Pueden producirse interrupciones por motivos de mantenimiento, actualización o circunstancias técnicas ajenas a nuestra voluntad.",
        "p2": "Harmonia no podrá ser considerada responsable de estas interrupciones."
      },
      "modifications": {
        "title": "Modificación de los Términos de Uso",
        "p1": "Harmonia se reserva el derecho de modificar estos Términos de Uso en cualquier momento. Los usuarios serán informados de cualquier modificación sustancial a través de la plataforma.",
        "highlight1": "La continuación del uso tras la modificación implica la aceptación de las nuevas condiciones."
      },
      "droit": {
        "title": "Derecho aplicable y jurisdicción",
        "p1": "Estos Términos de Uso se rigen por el derecho beninés. En caso de litigio, y a falta de resolución amistosa, serán competentes los tribunales de Benín."
      },
      "contact": {
        "title": "Contacto",
        "p1": "Para cualquier guía de uso de la plataforma, consulta nuestra documentación disponible directamente en Harmonia."
      }
    }
  },
  "confidentialite": {
    "title": "Política de Privacidad",
    "stats": {
      "sections": "Secciones",
      "gdpr": "Conforme con el RGPD",
      "secure": "Datos seguros"
    },
    "sections": {
      "intro": {
        "title": "Introducción",
        "p1": "Harmonia es una plataforma social mundial disponible en la web y en móvil, que permite a sus usuarios publicar contenido, interactuar, participar en concursos y jugar juegos de cultura general y estrategia.",
        "p2": "Esta Política de Privacidad te informa de manera transparente sobre los datos que recopilamos, cómo los utilizamos, tus derechos y las medidas adoptadas para proteger tu privacidad.",
        "highlight1": "Al usar Harmonia, aceptas las prácticas descritas en esta política."
      },
      "responsable": {
        "title": "Responsable del tratamiento",
        "p1": "El responsable del tratamiento de los datos personales recopilados a través de Harmonia es el equipo directivo de la plataforma Harmonia, entidad registrada en Benín.",
        "p2": "Para cualquier pregunta relacionada con tus datos personales, el ejercicio de tus derechos o cualquier reclamación, contáctanos directamente en esta dirección."
      },
      "donnees": {
        "title": "Datos recopilados",
        "sub1": "Registro directo",
        "bullets1": [
          "Apellido y nombre",
          "Dirección de correo electrónico",
          "Fecha de nacimiento"
        ],
        "sub2": "Mediante proveedor externo (Google, Facebook, etc.)",
        "bullets2": [
          "Apellido y nombre",
          "Dirección de correo electrónico",
          "Fecha de nacimiento (a completar posteriormente)"
        ],
        "sub3": "Datos de perfil y contenido publicado",
        "p1": "Controlas la visibilidad de cada información de tu perfil y de cada publicación (PRO, Amigos, Amigos de amigos, Privado).",
        "sub4": "Mensajería",
        "p2": "Los mensajes privados y las conversaciones grupales son estrictamente confidenciales, accesibles únicamente para los participantes de cada conversación.",
        "sub5": "Datos de pago",
        "p3": "Tratados exclusivamente por nuestros proveedores certificados. Harmonia nunca almacena directamente tus datos bancarios.",
        "sub6": "Tiendas pro",
        "highlight1": "Los usuarios PRO pueden crear una tienda con un enlace URL público. Recopilamos la información de la tienda, los productos publicados (cada uno con su propio enlace web) y los datos de personalización del sitio asociado."
      },
      "utilisation": {
        "title": "Uso de los datos",
        "bullets1": [
          "Gestión de tu cuenta y autenticación",
          "Funciones sociales (publicaciones, mensajería, amigos, grupos)",
          "Concursos, juegos y etapas finales presenciales a nivel mundial",
          "Difusión en tiempo real de información sobre los concursos y la actividad de la plataforma",
          "Gestión de tus suscripciones y servicios de pago",
          "Creación y disponibilidad de las tiendas pro y los enlaces web asociados",
          "Aplicación de los límites de publicación diarios (1/día estándar, 3/día PRO) para reforzar la calidad de la información",
          "Anuncios internos provenientes de usuarios suscritos",
          "Seguridad, prevención de fraudes y moderación de contenido"
        ],
        "highlight1": "Nos comprometemos a nunca vender, alquilar o transmitir tus datos a terceros con fines comerciales."
      },
      "concours": {
        "title": "Concursos y eventos presenciales",
        "p1": "Algunos concursos culminan en una etapa final presencial organizada por Harmonia que puede celebrarse en cualquier parte del mundo.",
        "highlight1": "Harmonia no recopila ningún dato adicional para estos eventos. No se solicita ningún documento de identidad, dirección o ubicación.",
        "p2": "Los jurados expertos y los países anfitriones son seleccionados aleatoriamente por Harmonia para garantizar la equidad y prevenir el fraude.",
        "sub1": "Información en tiempo real",
        "p3": "Harmonia difunde en tiempo real información sobre el desarrollo de los concursos, a partir de datos ya recopilados en el marco normal del uso de la plataforma. Esta difusión no da lugar a ninguna recopilación de datos adicional."
      },
      "publicite": {
        "title": "Publicidad",
        "p1": "Al usar Harmonia, aceptas recibir publicaciones publicitarias provenientes exclusivamente de usuarios suscritos a un plan publicitario de Harmonia.",
        "highlight1": "Ninguna red publicitaria externa. No se difunde publicidad de terceros externos en Harmonia."
      },
      "securite": {
        "title": "Alojamiento y seguridad",
        "p1": "Tus datos se alojan en servidores ubicados en Europa, cumpliendo con las normas de seguridad vigentes.",
        "bullets1": [
          "Cifrado de datos sensibles",
          "Acceso restringido a los datos según los roles",
          "Supervisión continua de la infraestructura",
          "Limitación del número de publicaciones diarias, para prevenir comportamientos abusivos"
        ],
        "sub1": "Protección de la API y de los sistemas técnicos",
        "p2": "La API backend de Harmonia está reservada para un uso interno exclusivo. Todo acceso no autorizado está prohibido y es susceptible de acciones judiciales. Harmonia recopila los registros técnicos (conexiones, direcciones IP) para detectar y perseguir todo acceso fraudulento."
      },
      "partage": {
        "title": "Compartición de datos",
        "highlight1": "Tus datos nunca se comparten con fines comerciales o publicitarios externos.",
        "bullets1": [
          "Proveedores técnicos sujetos a estrictas obligaciones contractuales de confidencialidad",
          "Obligaciones legales (procedimiento judicial o requerimiento de una autoridad competente)"
        ],
        "p1": "El contenido de una tienda pro (productos, descripción, personalización) se hace accesible públicamente a través de su enlace web en cuanto el usuario PRO decide publicar su tienda."
      },
      "mineurs": {
        "title": "Usuarios menores de edad",
        "p1": "Harmonia es accesible para todos los usuarios sin restricción de edad. El talento no tiene edad y el conocimiento es para todos.",
        "highlight1": "Para cualquier servicio de pago, un menor debe obtener el consentimiento explícito de su padre, madre o tutor legal."
      },
      "droits": {
        "title": "Tus derechos (RGPD)",
        "bullets1": [
          "Derecho de acceso — consultar tus datos",
          "Derecho de rectificación — corregir datos inexactos",
          "Derecho de supresión — eliminar tu cuenta y tus datos",
          "Derecho a la portabilidad — exportar tus datos",
          "Derecho de oposición — a ciertos tratamientos",
          "Derecho a retirar el consentimiento en cualquier momento"
        ],
        "highlight1": "Para ejercer tus derechos: harmonia@harmoniaworld.world"
      },
      "conservation": {
        "title": "Conservación de los datos",
        "p1": "Tus datos se conservan durante toda la duración de tu uso activo de la plataforma.",
        "bullets1": [
          "Datos identificables eliminados al cerrar la cuenta",
          "Datos anonimizados que pueden conservarse con fines estadísticos",
          "Tienda pro y productos asociados eliminados al cerrar la cuenta; los enlaces web asociados dejan de funcionar"
        ]
      },
      "cookies": {
        "title": "Cookies y tecnologías de seguimiento",
        "highlight1": "Ninguna herramienta de seguimiento de terceros (sin Google Analytics ni rastreadores publicitarios).",
        "p1": "Solo se utilizan cookies técnicas esenciales (sesión, autenticación, seguridad). En móvil, se almacenan localmente en tu dispositivo tokens de autenticación seguros, incluso cuando eliges permanecer conectado."
      },
      "responsabilite": {
        "title": "Responsabilidad de los usuarios",
        "p1": "Cada usuario es el único y total responsable de los contenidos que publica en Harmonia, incluido el contenido de una tienda pro y sus enlaces web asociados.",
        "p2": "Harmonia se reserva el derecho de suspender todo contenido no conforme tras su revisión por parte de sus administradores, incluida una tienda pro o un producto publicado."
      },
      "modifications": {
        "title": "Modificaciones de la política",
        "p1": "Harmonia se reserva el derecho de modificar esta política en cualquier momento. En caso de modificación sustancial, los usuarios serán notificados a través de la plataforma.",
        "highlight1": "La continuación del uso tras la modificación implica la aceptación de las nuevas condiciones."
      },
      "contact": {
        "title": "Contacto",
        "p1": "Consulta también nuestra guía de uso disponible directamente en Harmonia."
      }
    }
  },
  "guideScreen": {
    "header": {
      "title": "Guía de uso",
      "subtitle": "Todo sobre Harmonia"
    },
    "intro": {
      "text": "Bienvenido a la guía de uso. Toca un capítulo para desplegarlo y descubrir cómo usar cada función.",
      "allMembers": "Todos los miembros",
      "proFeatures": "Funciones PRO"
    },
    "chapters": {
      "compte": {
        "title": "Conexión y Cuenta",
        "steps": {
          "step1": {
            "title": "Crear una cuenta",
            "desc": "En la pantalla de inicio, toca «Crear una cuenta». Ingresa tu nombre, apellido, dirección de email y una contraseña. Marca los términos de uso y toca «Registrarse»."
          },
          "step2": {
            "title": "Verificar tu email",
            "desc": "Tras el registro, se te envía un email de verificación. Ábrelo y haz clic en el enlace para activar tu cuenta, luego vuelve a la aplicación."
          },
          "step3": {
            "title": "Iniciar sesión",
            "desc": "Ingresa tu email y contraseña, luego toca «Iniciar sesión»."
          },
          "step4": {
            "title": "Permanecer conectado",
            "desc": "Puedes elegir permanecer conectado a tu cuenta. En ese caso, cada vez que abras la aplicación, llegarás directamente al feed sin tener que volver a ingresar tu contraseña. Esta elección es tuya en todo momento: si te desconectas explícitamente sin haber activado esta opción, verás la pantalla de inicio de sesión la próxima vez que abras la aplicación."
          },
          "step5": {
            "title": "Contraseña olvidada",
            "desc": "En la pantalla de inicio de sesión, toca «Contraseña olvidada». Ingresa tu email. Recibirás un código de 6 dígitos. Ingrésalo y luego crea una nueva contraseña."
          },
          "step6": {
            "title": "Conexión con Google",
            "desc": "Toca «Continuar con Google» para conectarte con un clic. En el primer inicio de sesión, deberás aceptar los términos de uso."
          }
        }
      },
      "actu": {
        "title": "Feed de noticias",
        "steps": {
          "step1": {
            "title": "Navegar por el feed",
            "desc": "La pestaña Feed 🏠 muestra las publicaciones de la comunidad. Desplázate hacia abajo para cargar más contenido. Toca el ícono de filtro para ordenar: Todo · Publicaciones · Imágenes · Videos · Música."
          },
          "step2": {
            "title": "Ocultar o mostrar el encabezado",
            "desc": "Haz doble toque en la zona del encabezado para ocultarlo y ganar espacio de lectura. Repite para volver a mostrarlo."
          },
          "step3": {
            "title": "Tu saldo CFA",
            "desc": "Tu saldo CFA se muestra en el encabezado. Tócalo para abrir directamente la pantalla de recarga y agregar fondos vía Mobile Money."
          },
          "step4": {
            "title": "Actualizar el feed",
            "desc": "Desliza hacia abajo desde la parte superior del feed para actualizar. También puedes tocar el ícono de actualización 🔄 en el encabezado."
          },
          "step5": {
            "title": "Crear una publicación",
            "desc": "Toca el botón «+» en el encabezado. Redacta tu mensaje (máx. 1000 caracteres). Elige la visibilidad: Público · Amigos · Privado · PRO. Toca «Publicar»."
          },
          "step6": {
            "title": "Añadir una foto o video a tu publicación",
            "desc": "Los miembros PRO pueden adjuntar una foto o un video a sus publicaciones. Aparece un botón 📷 Foto y 🎬 Video en el formulario de creación."
          },
          "step7": {
            "title": "Dar me gusta a una publicación",
            "desc": "Toca el pulgar 👍 debajo de una publicación para darle me gusta. Se anima un reflejo violeta. Tócalo de nuevo para cancelar. Toca el contador de me gusta para ver la lista de personas que dieron me gusta."
          },
          "step8": {
            "title": "Comentar",
            "desc": "Toca el ícono 💬 para abrir los comentarios de la publicación. Redacta tu respuesta en el cuadro de texto de abajo y envía."
          },
          "step9": {
            "title": "Compartir una publicación",
            "desc": "Toca el ícono de compartir 🔄 para compartir una publicación pública en el feed. Toca el número de compartidos mostrado para ver la lista de usuarios que compartieron."
          },
          "step10": {
            "title": "Guardar una publicación",
            "desc": "Toca el ícono 🔖 debajo de una publicación para guardarla. Encuentra todos tus guardados tocando el ícono dedicado en el encabezado."
          },
          "step11": {
            "title": "Denunciar contenido",
            "desc": "Toca el ícono de denuncia ⚠️ para denunciar una publicación inapropiada al equipo de Harmonia."
          },
          "step12": {
            "title": "Editar o eliminar tus publicaciones",
            "desc": "En tus propias publicaciones, un ícono ✏️ permite editar el texto y un ícono 🗑️ permite eliminar. Estos botones solo aparecen en tus propias publicaciones."
          },
          "step13": {
            "title": "Ver una imagen en grande",
            "desc": "Toca una imagen en el feed para abrirla. Doble toque para mostrarla en pantalla completa. Vuelve a tocar para cerrar."
          },
          "step14": {
            "title": "Reproducir un video o audio",
            "desc": "Las publicaciones de video muestran un botón ▶️. Las presentaciones musicales tienen un reproductor integrado con Play/Pausa y barra de progreso. Toca ❤️ para votar."
          },
          "step15": {
            "title": "Votar por las creaciones del feed",
            "desc": "Las presentaciones artísticas y de performance aparecen en el feed. Desplázate verticalmente para recorrer videos estilo TikTok. Toca ❤️ para votar por tu favorito."
          },
          "step16": {
            "title": "Buscar en el feed",
            "desc": "Toca el ícono 🔍 en el encabezado para abrir la barra de búsqueda y encontrar publicaciones o usuarios."
          },
          "step17": {
            "title": "Notificaciones",
            "desc": "Toca el ícono 🔔 en el encabezado para consultar tus notificaciones (me gusta, comentarios, solicitudes de amistad, etc.)."
          }
        }
      },
      "jeux": {
        "title": "Centro de Talentos",
        "steps": {
          "step1": {
            "title": "Explorar las disciplinas",
            "desc": "La pestaña Juegos 🎮 abre el Centro de Talentos con 6 categorías: Juegos de Estrategia · Conocimientos · Artes · Performance · Música · Artesanía. Desplázate para verlas todas."
          },
          "step2": {
            "title": "Descubrir un juego en detalle",
            "desc": "Mantén presionado (≈ 0,4 s) cualquier juego para abrir su ficha: descripción, tagline e insignia de trofeo. Toca «Comenzar la aventura» o cierra la ficha."
          },
          "step3": {
            "title": "Abrir un juego",
            "desc": "Toca normalmente un juego para abrirlo en pantalla completa. El botón ⓘ en el encabezado muestra el banner de presentación de Harmonia."
          },
          "step4": {
            "title": "Unirse a una sesión",
            "desc": "En cada juego, la pestaña «Explorar» lista las sesiones disponibles (gratuitas o de pago en CFA). Toca «Participar» para unirte. La pestaña «Mis Sesiones» muestra las que ya te uniste."
          },
          "step5": {
            "title": "Verdadero o Falso — Responder una pregunta",
            "desc": "Pestaña Sesiones → elige una sesión → un grupo. Toca «Responder». La pregunta se muestra con una barra de progreso. Toca «VERDADERO» (verde) o «FALSO» (rojo). Navega entre preguntas con Anterior / Siguiente."
          },
          "step6": {
            "title": "Verdadero o Falso — Grupos bloqueados",
            "desc": "Algunos grupos requieren un puntaje mínimo para acceder. Si tu puntaje es insuficiente, el grupo muestra un ícono 🔒 y el puntaje requerido."
          },
          "step7": {
            "title": "Verdadero o Falso — Ver tus respuestas",
            "desc": "La pestaña «Respuestas» te permite consultar las preguntas que respondiste y tu elección VERDADERO/FALSO, sin ver los puntajes."
          },
          "step8": {
            "title": "Verdadero o Falso — Resultados",
            "desc": "La pestaña «Resultados» muestra tus puntajes y las respuestas correctas. Esta información solo aparece cuando el administrador la revela. Antes de eso, se muestra un mensaje «En espera»."
          },
          "step9": {
            "title": "Awalé y Damas — Unirse y jugar",
            "desc": "Elige una sesión en «Mis Sesiones». Cuando se lanza el run, toca «Jugar ahora». Una cuenta regresiva de preparación precede a cada partida. Siempre apareces en la parte inferior del tablero."
          },
          "step10": {
            "title": "Damas — Jugar en el tablero",
            "desc": "Toca una de tus piezas para seleccionarla — las casillas válidas se iluminan en verde (movimiento) o naranja (captura posible). Toca la casilla de destino para jugar. Las damas ♔ pueden moverse en todas las direcciones."
          },
          "step11": {
            "title": "Awalé — Jugar en el tablero",
            "desc": "Tus huecos (fila inferior) se iluminan en verde cuando es tu turno. Toca un hueco con semillas para jugar. El puntaje se muestra arriba. En caso de empate, se inicia automáticamente una ronda decisiva «Primero a 12»."
          },
          "step12": {
            "title": "Clasificación de partidas (Awalé y Damas)",
            "desc": "La pestaña «Clasificación» lista tus sesiones. Toca una sesión para ver los runs y los resultados de cada partida (en curso 🔵 o terminada ✅) con el ganador destacado 🏆."
          },
          "step13": {
            "title": "Enviar una creación — Artes",
            "desc": "Pestaña «Enviar» → elige un run abierto. Completa cada espacio con una imagen (JPG · PNG · WEBP). Añade una descripción si lo deseas. El botón de envío se activa cuando todos los espacios están completos."
          },
          "step14": {
            "title": "Enviar — Performance y Artesanía",
            "desc": "Mismo principio que Artes pero con videos (MP4 · MOV · WEBM). Todos los espacios deben completarse. Las creaciones ya enviadas están bloqueadas y muestran el ícono 🔒."
          },
          "step15": {
            "title": "Enviar — Música",
            "desc": "Selecciona tus archivos de audio (MP3 · WAV · M4A) desde tu galería. Completa todos los espacios requeridos, añade una descripción opcional, luego envía."
          },
          "step16": {
            "title": "Clasificación creativa y Votos",
            "desc": "La pestaña «Clasificación» muestra el podio 🥇🥈🥉 con el número de votos ❤️ de cada participante. Se actualiza en cuanto el administrador abre las votaciones."
          }
        }
      },
      "messages": {
        "title": "Mensajes",
        "steps": {
          "step1": {
            "title": "Historial de conversaciones",
            "desc": "La pestaña Historial 🕐 lista tus conversaciones privadas y grupales. Una insignia roja indica mensajes no leídos. La vista previa del último mensaje muestra un emoji según su tipo: 📷 Foto · 🎬 Video · 🎵 Audio · 📁 Archivo."
          },
          "step2": {
            "title": "Amigos en línea",
            "desc": "La pestaña «En línea» 🟢 muestra tus amigos actualmente conectados (punto verde). Toca un amigo para iniciar una conversación directamente."
          },
          "step3": {
            "title": "Mis amigos",
            "desc": "La pestaña «Amigos» 👥 lista todos tus amigos (en línea o desconectados). Toca un nombre para abrir la conversación."
          },
          "step4": {
            "title": "Grupos",
            "desc": "La pestaña «Grupos» muestra tus conversaciones grupales. Toca un grupo para abrirlo."
          },
          "step5": {
            "title": "Buscar una conversación",
            "desc": "Toca el ícono 🔍 en el encabezado para mostrar la barra de búsqueda. Funciona en cada pestaña — Historial, En línea, Amigos y Grupos."
          },
          "step6": {
            "title": "Sincronización manual",
            "desc": "Toca el ícono de sincronización, visible directamente en el encabezado «Mensajes», para iniciar una sincronización. Aparece una animación de 3 pasos: Inicialización → Actualización → Sincronización de datos. Una respuesta visual confirma el éxito o indica un error."
          },
          "step7": {
            "title": "Enviar un mensaje de texto",
            "desc": "Escribe en el cuadro de texto (máx. 1000 caracteres) y toca ➤ para enviar. El estado se muestra debajo de tu burbuja: ⏳ enviando · ✓ enviado · ✓✓ leído."
          },
          "step8": {
            "title": "Reenviar un mensaje fallido",
            "desc": "Si un mensaje no pudo enviarse tras 3 intentos, su burbuja aparece con un borde rojo y un botón «Reintentar» 🔁. Tócalo para reenviar."
          },
          "step9": {
            "title": "Enviar contenido multimedia (PRO)",
            "desc": "Los miembros PRO ven un botón 📎 a la izquierda del cuadro de texto. Toca para adjuntar una imagen, video o documento (PDF, Word, Excel, etc.) a tu mensaje."
          },
          "step10": {
            "title": "Grabar y enviar una nota de voz (PRO)",
            "desc": "Cuando el cuadro de texto está vacío, los miembros PRO ven un botón 🎤. Mantén presionado para grabar. Toca ⏹ para detener. Aparece un reproductor de vista previa con Play/Pausa, barra de progreso y duración total. Toca ➤ para enviar o 🗑️ para cancelar."
          },
          "step11": {
            "title": "Responder en un grupo",
            "desc": "Mantén presionado un mensaje para abrir las acciones. Elige «Responder públicamente» 🌍 (todo el grupo ve la respuesta) o «Responder en privado» 🔒 (visible solo para ti y el destinatario)."
          },
          "step12": {
            "title": "Cambiar la visibilidad de tu respuesta",
            "desc": "Doble toque en tu propia respuesta dentro de un grupo para alternar entre pública y privada. El ícono 👁 o 🚫👁 confirma el estado actual. También puedes usar mantener presionado → «Hacer privada» / «Hacer visible»."
          },
          "step13": {
            "title": "Eliminar un mensaje",
            "desc": "Mantén presionado uno de tus mensajes, luego toca «Eliminar». El mensaje es reemplazado por «Mensaje eliminado» para todos los participantes."
          },
          "step14": {
            "title": "Ver una imagen en pantalla completa",
            "desc": "Doble toque en una imagen dentro de una conversación para mostrarla en pantalla completa. Vuelve a tocar o la cruz ✕ para cerrar."
          },
          "step15": {
            "title": "Banner sin conexión",
            "desc": "Si se pierde la conexión, aparece un banner rojo en la parte superior de la conversación. Tus mensajes quedan en espera y se reenvían automáticamente en cuanto vuelve la conexión."
          }
        }
      },
      "amis": {
        "title": "Red y Amigos",
        "steps": {
          "step1": {
            "title": "Sugerencias de amigos",
            "desc": "La pestaña Red 👥 muestra personas que podrías conocer. Desplázate para cargar más sugerencias. Toca el botón ➕ a la derecha de un nombre para enviarle una solicitud de amistad."
          },
          "step2": {
            "title": "Buscar un usuario",
            "desc": "Toca la pestaña «Búsqueda» 🔍. Escribe un nombre o apellido en la barra, luego toca la flecha → para iniciar la búsqueda. Toca ➕ para enviar una solicitud a un resultado."
          },
          "step3": {
            "title": "Solicitudes recibidas",
            "desc": "La pestaña «Solicitudes» 📩 muestra una insignia roja si tienes solicitudes pendientes. Subpestaña «Recibidas»: toca «Aceptar» para ser amigos, o «Rechazar» para declinar."
          },
          "step4": {
            "title": "Solicitudes enviadas",
            "desc": "Subpestaña «Enviadas»: encuentra todas tus solicitudes en espera de respuesta. Toca «Cancelar» para retirar una solicitud."
          },
          "step5": {
            "title": "Ver el perfil de un usuario",
            "desc": "En las sugerencias, resultados de búsqueda o solicitudes, toca el nombre o avatar de un usuario para abrir su ficha de perfil."
          }
        }
      },
      "profil": {
        "title": "Mi Perfil",
        "steps": {
          "step1": {
            "title": "Editar la foto de perfil",
            "desc": "En la pantalla de Perfil, toca el ícono 📷 naranja sobre tu avatar para elegir una nueva foto desde tu galería. La actualización es inmediata."
          },
          "step2": {
            "title": "Saldo CFA y Trofeos",
            "desc": "Dos tarjetas de colores muestran tu saldo CFA 💰 y tu número de trofeos 🏆 ganados. Estos contadores se actualizan automáticamente."
          },
          "step3": {
            "title": "Recargar el saldo",
            "desc": "Toca la tarjeta «Recargar mi saldo» (billetera dorada) para acceder a la pantalla de recarga. También puedes recargar desde el feed tocando tu saldo CFA."
          },
          "step4": {
            "title": "Editar tu información",
            "desc": "Toca «Ajustes» ⚙️ en la sección «Mi cuenta». Se abre un panel desde abajo con los campos Apellido, Nombre y Fecha de nacimiento. Edita y luego toca «Guardar»."
          },
          "step5": {
            "title": "Privacidad",
            "desc": "Toca «Privacidad» 🛡️ para acceder a los ajustes de privacidad, datos y seguridad de tu cuenta."
          },
          "step6": {
            "title": "Acceder a la guía",
            "desc": "Toca «Guía de uso» 📖 en la sección «Mi cuenta» para abrir esta guía en cualquier momento."
          },
          "step7": {
            "title": "Crear una publicación desde el perfil",
            "desc": "En la sección «Publicaciones», toca el botón «Publicar» (degradado rosa-naranja). El formulario de creación se abre con las mismas opciones que en el feed."
          },
          "step8": {
            "title": "Gestionar tus publicaciones",
            "desc": "Tus publicaciones se listan en la parte inferior del perfil. En cada una: ✏️ para editar el texto · 🗑️ para eliminar (se solicita confirmación). Las acciones de me gusta, comentar, compartir y guardar también están disponibles."
          },
          "step9": {
            "title": "Añadir contenido multimedia a una publicación (PRO)",
            "desc": "Los miembros PRO ven botones 📷 Foto y 🎬 Video en el formulario de creación. Se muestra una vista previa antes de publicar. Toca ✖ para quitar el contenido multimedia."
          },
          "step10": {
            "title": "Cerrar sesión",
            "desc": "Toca el ícono de cierre de sesión 🚪 en la parte superior derecha del perfil. Se te pedirá confirmación antes del cierre efectivo. Si habías elegido permanecer conectado, este cierre de sesión es definitivo: verás la pantalla de inicio de sesión la próxima vez que abras la aplicación."
          }
        }
      },
      "pro": {
        "title": "Estatus PRO ⭐",
        "steps": {
          "step1": {
            "title": "Insignia PRO visible",
            "desc": "La insignia ⭐ PRO aparece en tu perfil y es visible para todos los miembros de la comunidad Harmonia."
          },
          "step2": {
            "title": "Publicaciones enriquecidas",
            "desc": "Los miembros PRO pueden adjuntar una foto o video a sus publicaciones en el feed. Las publicaciones con visibilidad «PRO» solo son visibles para otros miembros PRO."
          },
          "step3": {
            "title": "Contenido multimedia en los mensajes",
            "desc": "Como miembro PRO, puedes enviar imágenes, videos y documentos (PDF, Word, Excel, etc.) en conversaciones privadas y grupales."
          },
          "step4": {
            "title": "Notas de voz",
            "desc": "Los miembros PRO pueden grabar y enviar notas de voz en los mensajes. Un reproductor de vista previa integrado permite escuchar la grabación antes de enviarla."
          },
          "step5": {
            "title": "Pasar al estatus PRO",
            "desc": "Toca «Recargar mi saldo» en tu perfil o tu saldo CFA en el feed. Recarga tu cuenta vía Mobile Money para acceder a las funciones PRO."
          }
        }
      },
      "market": {
        "title": "Tienda Pro y Market ⭐",
        "steps": {
          "step1": {
            "title": "Abrir el Market",
            "desc": "Un 6º botón «Market» 🛍️ está disponible en la barra de navegación principal. Tócalo: la barra se desplaza y da paso a una nueva barra de navegación dedicada al Market, con 4 botones: Home, Todos los productos, Tiendas y Ajustes."
          },
          "step2": {
            "title": "Volver a la navegación principal",
            "desc": "Desde el Market, toca el botón «Home» 🏠 para volver a la barra de navegación principal de la aplicación."
          },
          "step3": {
            "title": "Explorar todos los productos",
            "desc": "El botón «Todos los productos» muestra el conjunto de productos publicados por las tiendas de la plataforma, de todos los vendedores."
          },
          "step4": {
            "title": "Explorar las tiendas",
            "desc": "El botón «Tiendas» muestra la lista de tiendas creadas por los miembros PRO en Harmonia."
          },
          "step5": {
            "title": "Crear tu tienda y sitio web (PRO)",
            "desc": "Como miembro PRO, el botón «Ajustes» ⚙️ del Market te permite crear tu propia tienda. Harmonia genera entonces un verdadero sitio web para tu tienda, accesible mediante un enlace URL público funcional en la web, además de ser visible directamente en la plataforma."
          },
          "step6": {
            "title": "Personalizar el sitio de tu tienda (PRO)",
            "desc": "Desde «Ajustes», personaliza el diseño y numerosos parámetros del sitio de tu tienda: presentación, diseño y otros elementos visuales, para que se parezca a ti."
          },
          "step7": {
            "title": "Publicar productos (PRO)",
            "desc": "Siempre desde «Ajustes», añade y actualiza los productos de tu tienda. Cada producto publicado dispone automáticamente de su propio enlace web, que permite consultarlo y compartirlo directamente."
          },
          "step8": {
            "title": "Gestionar las tiendas seguidas",
            "desc": "En «Ajustes», encuentra la lista de tiendas a las que estás suscrito. Puedes dejar de seguir una tienda en cualquier momento desde esta pantalla."
          },
          "step9": {
            "title": "Encontrar tus productos guardados",
            "desc": "Siempre en «Ajustes», consulta la lista de productos que has guardado durante tu navegación en el Market."
          }
        }
      }
    }
  },
  "politiqueCookies": {
    "title": "Política de Cookies",
    "stats": {
      "sections": "Secciones",
      "zeroTracking": "Cero rastreo",
      "essentialOnly": "Solo cookies esenciales"
    },
    "sections": {
      "definition": {
        "title": "¿Qué es una cookie?",
        "p1": "Una cookie es un pequeño archivo de texto que se coloca en tu dispositivo (ordenador, tableta, smartphone) durante la navegación. Permite a la plataforma recordar cierta información para mejorar tu experiencia.",
        "highlight1": "Las cookies no pueden dañar tu dispositivo y no contienen ningún virus."
      },
      "politique": {
        "title": "Harmonia y las cookies",
        "p1": "Harmonia adopta una política estricta y minimalista en materia de cookies.",
        "highlight1": "No utilizamos ninguna cookie con fines publicitarios externos, de perfilado o de seguimiento por terceros.",
        "p2": "No se utiliza ninguna herramienta de análisis externa (como Google Analytics). Tus datos de navegación nunca se transmiten a socios publicitarios externos."
      },
      "utilises": {
        "title": "Cookies que utilizamos",
        "p1": "Harmonia utiliza únicamente cookies técnicas estrictamente necesarias para el buen funcionamiento de la plataforma.",
        "sub1": "Cookies de sesión y autenticación",
        "p2": "Permiten mantenerte conectado a tu cuenta Harmonia. Creadas al iniciar tu sesión, se eliminan por defecto al cerrarla.",
        "highlight1": "Puedes elegir permanecer conectado: en ese caso, se conserva un token de autenticación persistente para evitar volver a ingresar tu contraseña. Esta elección te pertenece y puede modificarse en cualquier momento.",
        "sub2": "Cookies relacionadas con proveedores externos (Google, etc.)",
        "p3": "Cuando te conectas mediante Google u otro proveedor, este puede colocar sus propias cookies como parte del proceso de autenticación. Estas se rigen por su propia política de privacidad.",
        "sub3": "Cookies de seguridad",
        "p4": "Contribuyen a proteger tu cuenta contra intentos de fraude y acceso no autorizado.",
        "sub4": "Cookies relacionadas con los pagos",
        "p5": "Durante una transacción (suscripción, concurso de pago, tienda pro), los proveedores de pago pueden colocar cookies técnicas limitadas a la duración de la transacción para garantizar su seguridad."
      },
      "nonUtilises": {
        "title": "Cookies que NO utilizamos",
        "p1": "Por total transparencia, esto es lo que Harmonia no utiliza:",
        "bullets1": [
          "Cookies publicitarias — sin publicidad externa, sin segmentación",
          "Cookies de seguimiento analítico de terceros — sin herramienta externa de análisis",
          "Cookies de perfilado conductual — sin creación de perfil publicitario"
        ]
      },
      "mobile": {
        "title": "Aplicación móvil",
        "p1": "En la aplicación móvil de Harmonia, no se utilizan cookies en sentido estricto. Se emplean tecnologías similares (tokens de autenticación seguros, almacenamiento local) para garantizar el buen funcionamiento.",
        "highlight1": "Si eliges permanecer conectado, se conserva un token de autenticación localmente en tu dispositivo. Sigues siendo dueño de esta elección y puedes desconectarte en cualquier momento para eliminarlo.",
        "p2": "Estos datos se almacenan únicamente en tu dispositivo y nunca se comparten con terceros con fines publicitarios."
      },
      "duree": {
        "title": "Duración de conservación",
        "bullets1": [
          "Cookie de sesión — eliminada al cerrar la sesión",
          "Cookie de autenticación — duración de tu sesión activa, o hasta la desconexión explícita si «permanecer conectado» está activado",
          "Cookie de seguridad — duración de tu sesión activa",
          "Cookie de pago — solo durante la transacción"
        ]
      },
      "gestion": {
        "title": "Gestión de tus cookies",
        "sub1": "A través de tu navegador",
        "bullets1": [
          "Google Chrome: Configuración › Privacidad y seguridad › Cookies",
          "Mozilla Firefox: Configuración › Privacidad y seguridad › Cookies",
          "Safari: Preferencias › Privacidad › Cookies",
          "Microsoft Edge: Configuración › Privacidad › Cookies"
        ],
        "highlight1": "Atención: desactivar las cookies técnicas esenciales puede impedir tu conexión a Harmonia.",
        "sub2": "Desde tu dispositivo móvil",
        "p1": "Gestiona los permisos de la aplicación Harmonia directamente desde la configuración de tu dispositivo iOS o Android.",
        "sub3": "Opción «permanecer conectado»",
        "p2": "Tanto en la web como en móvil, esta opción es facultativa y permanece bajo tu control exclusivo. Una desconexión manual elimina la cookie o el token asociado."
      },
      "modifications": {
        "title": "Modificaciones de la política",
        "p1": "Harmonia se reserva el derecho de modificar esta política en cualquier momento, en particular en caso de evolución técnica o cambio normativo. Los usuarios serán informados de cualquier modificación a través de la plataforma.",
        "highlight1": "La continuación del uso tras la modificación implica la aceptación de las nuevas condiciones."
      },
      "contact": {
        "title": "Contacto",
        "p1": "Consulta nuestra guía de uso disponible directamente en Harmonia para cualquier pregunta adicional."
      }
    }
  },
  "reglesCommunautaires": {
    "title": "Normas de la Comunidad",
    "stats": {
      "sections": "Secciones",
      "forEveryone": "Para todos",
      "healthyCommunity": "Comunidad saludable"
    },
    "sections": {
      "respect": {
        "title": "Respeto y cordialidad",
        "p1": "Harmonia es un espacio de intercambio y expresión. Cada miembro debe tratar a los demás con respeto, independientemente de su origen, cultura, religión, género, edad u opiniones.",
        "sub1": "Está prohibido:",
        "bullets1": [
          "Insultar, humillar o degradar a otro miembro",
          "Acosar, amenazar o intimidar a una persona o grupo",
          "Hacer comentarios discriminatorios o despectivos hacia una comunidad",
          "Fomentar o glorificar la violencia de cualquier forma"
        ]
      },
      "contenuInterdit": {
        "title": "Contenido prohibido",
        "p1": "Los siguientes contenidos están estrictamente prohibidos en Harmonia, sea cual sea su forma y nivel de visibilidad:",
        "sub1": "Contenido sexual y desnudez",
        "p2": "Está prohibida toda publicación de carácter sexual explícito o que contenga desnudez.",
        "sub2": "Odio y discriminación",
        "p3": "Todo contenido que incite al odio hacia una persona o grupo por su raza, etnia, religión, nacionalidad, género, orientación sexual o discapacidad.",
        "sub3": "Violencia y contenido impactante",
        "p4": "Contenidos que representen actos de violencia reales, escenas de tortura, mutilación o cualquier contenido susceptible de traumatizar a los miembros.",
        "sub4": "Desinformación",
        "p5": "Está prohibida la publicación deliberada de información falsa con el fin de engañar, manipular o perjudicar.",
        "sub5": "Violación de la privacidad y suplantación",
        "bullets1": [
          "Publicar información personal de un tercero sin su consentimiento",
          "Hacerse pasar por otra persona, marca o entidad oficial"
        ]
      },
      "publications": {
        "title": "Normas de publicación",
        "sub1": "Límite diario",
        "bullets1": [
          "Usuarios estándar: 1 publicación por día",
          "Usuarios PRO: 3 publicaciones por día"
        ],
        "highlight1": "Este límite refuerza la calidad de la información compartida y fomenta la calidad sobre la cantidad.",
        "sub2": "Autenticidad del contenido",
        "p1": "Te comprometes a publicar únicamente contenido del que eres autor o para el cual posees los derechos necesarios.",
        "sub3": "Responsabilidad según la visibilidad",
        "p2": "Eres el único responsable de tu contenido, sea cual sea el nivel de visibilidad elegido. La visibilidad PRO, accesible para toda la comunidad e incluida en su propio límite de 3 publicaciones diarias, implica una responsabilidad mayor."
      },
      "messagerie": {
        "title": "Mensajería y grupos",
        "p1": "Las normas de respeto y cordialidad también se aplican a la mensajería privada y los grupos de discusión. El carácter privado de un intercambio nunca justifica un comportamiento irrespetuoso.",
        "highlight1": "Está prohibido el envío de mensajes no solicitados de carácter comercial, publicitario o acosador."
      },
      "concours": {
        "title": "Concursos y competencias",
        "sub1": "Autenticidad de las participaciones",
        "p1": "Cada participante debe presentar únicamente creaciones originales de las que sea autor. Todo fraude o plagio conlleva la descalificación inmediata y definitiva.",
        "sub2": "Integridad del voto",
        "bullets1": [
          "Está prohibido votar a cambio de contraprestaciones (dinero, servicios)",
          "Está prohibido usar herramientas automatizadas para manipular los votos",
          "Está prohibido votar varias veces mediante varias cuentas"
        ],
        "highlight1": "Cada usuario autenticado dispone de un solo voto por candidato. Cualquier elusión conlleva la suspensión de los votos correspondientes.",
        "sub3": "Respeto entre competidores",
        "p2": "Está prohibido todo menosprecio, burla o ataque hacia otro participante. La competencia debe permanecer sana y respetuosa.",
        "sub4": "Juegos de estrategia y cultura general",
        "p3": "Los juegos (damas, Awalé, Verdadero o Falso…) deben practicarse con juego limpio. Está prohibido el uso de software de asistencia o cualquier medio desleal.",
        "sub5": "Información en tiempo real",
        "p4": "Harmonia difunde en tiempo real información sobre el desarrollo de los concursos y la actividad de la plataforma, para que todos los usuarios estén informados de manera equitativa y al mismo tiempo. Está prohibido cualquier intento de manipulación o desvío de esta difusión."
      },
      "publicite": {
        "title": "Publicidad y contenido comercial",
        "p1": "Solo los usuarios que se hayan suscrito a un plan publicitario de Harmonia están autorizados a publicar contenido publicitario en la plataforma.",
        "highlight1": "Está estrictamente prohibida toda prospección comercial no autorizada, promoción de actividades ilegales o difusión de enlaces fraudulentos."
      },
      "boutiques": {
        "title": "Tiendas pro",
        "p1": "Los usuarios PRO pueden crear una tienda en la plataforma, accesible a través de Harmonia y mediante un enlace URL público en la web. Cada producto publicado dispone de su propio enlace web.",
        "highlight1": "Las normas relativas al contenido prohibido y a la publicidad se aplican íntegramente al contenido de una tienda pro y de sus productos, incluso cuando se consultan mediante un enlace web público.",
        "sub1": "Prohibiciones específicas",
        "bullets1": [
          "Vender u ofrecer productos o servicios ilegales",
          "Publicar información engañosa sobre los productos ofrecidos",
          "Utilizar la tienda con fines de estafa o recopilación abusiva de datos de los visitantes"
        ],
        "p2": "El usuario PRO es el único responsable del contenido de su tienda. Toda tienda o producto no conforme puede ser suspendido, incluso mediante la desactivación del enlace web asociado."
      },
      "signalement": {
        "title": "Denuncia",
        "sub1": "Cómo denunciar",
        "p1": "Si detectas un contenido que infringe las normas, denúncialo mediante la función prevista para ello en la plataforma.",
        "sub2": "Tratamiento de las denuncias",
        "bullets1": [
          "Umbral de denuncias alcanzado → contenido en estado de revisión (no visible)",
          "Contenido conforme → recupera su visibilidad normal",
          "Contenido no conforme → suspendido de forma definitiva"
        ],
        "highlight1": "Todo uso abusivo de la función de denuncia es en sí mismo contrario a las normas de la comunidad."
      },
      "sanctions": {
        "title": "Consecuencias de las infracciones",
        "sub1": "Suspensión de contenido",
        "p1": "Todo contenido considerado contrario a las normas se suspende de forma definitiva y sin posibilidad de apelación. Harmonia no procede a la expulsión de usuarios; las medidas afectan a los contenidos, no a las personas.",
        "sub2": "Ausencia de reembolso",
        "p2": "La suspensión de un contenido de pago (visibilidad PRO o tienda pro) no da lugar a ningún reembolso.",
        "sub3": "Responsabilidad personal",
        "highlight1": "En caso de infracción grave de las leyes vigentes, Harmonia se reserva el derecho de transmitir los elementos necesarios a las autoridades competentes si la ley lo exige."
      },
      "api": {
        "title": "Prohibición de acceso a la API",
        "p1": "La API backend y los sistemas técnicos de Harmonia están reservados para un uso exclusivamente interno de la plataforma. Está estrictamente prohibido:",
        "bullets1": [
          "Acceder a la API fuera de las aplicaciones oficiales",
          "Utilizar scripts, robots o herramientas automatizadas para extraer datos",
          "Eludir los sistemas de seguridad o autenticación",
          "Interceptar las comunicaciones entre las aplicaciones y los servidores",
          "Explotar o intentar explotar cualquier fallo técnico"
        ],
        "highlight1": "Estos actos constituyen infracciones graves susceptibles de acciones judiciales. Harmonia coopera con las autoridades competentes para identificar y perseguir a los infractores.",
        "p2": "Todo fallo descubierto debe notificarse a harmonia@harmoniaworld.world sin ser explotado."
      },
      "evolution": {
        "title": "Evolución de las normas",
        "p1": "Harmonia se reserva el derecho de hacer evolucionar estas normas en cualquier momento, en función del desarrollo de la plataforma y de las necesidades de la comunidad.",
        "highlight1": "La continuación del uso tras la modificación implica la aceptación de las nuevas normas."
      },
      "contact": {
        "title": "Contacto",
        "p1": "Consulta nuestra guía de uso disponible directamente en Harmonia para cualquier pregunta."
      }
    }
  },
  "actuScreen": {
    "toasts": {
      "noConnection": "Sin conexión a internet",
      "mediaAccessRequired": "Se requiere acceso a los medios.",
      "imageAdded": "¡Imagen añadida!",
      "videoAdded": "¡Video añadido!",
      "cannotAddMedia": "No se pudo añadir el contenido multimedia",
      "contentRequired": "El contenido es obligatorio",
      "limitReached": "Límite de publicaciones alcanzado.",
      "postPublished": "¡Publicación publicada!",
      "cannotPublish": "No se pudo publicar",
      "reportRegistered": "¡Denuncia registrada!",
      "reportError": "Error al enviar la denuncia",
      "networkError": "Error de red",
      "postSanctioned": "Publicación sancionada ({{status}})",
      "adminError": "Error de administración"
    },
    "offlineBanner": "Sin conexión — Sin conexión",
    "doubleTapToShow": "Doble toque para mostrar",
    "loading": "Cargando...",
    "upToDate": "Estás al día ✓",
    "report": {
      "title": "Denunciar",
      "message": "¿Denunciar esta publicación?",
      "confirm": "Sí, denunciar",
      "cancel": "Cancelar"
    },
    "filters": {
      "all": "Todo",
      "posts": "Publicaciones",
      "images": "Imágenes",
      "videos": "Videos",
      "music": "Música"
    },
    "filterMenu": {
      "title": "Mostrar"
    },
    "adminStrike": {
      "title": "Sanción Directa",
      "selectSanction": "Selecciona la sanción:",
      "pending": "Poner en espera (Pendiente)",
      "lock": "Bloquear (Activo)",
      "cancel": "Cancelar"
    },
    "empty": {
      "offlineTitle": "Sin contenido sin conexión",
      "emptyFeedTitle": "Tu feed de noticias está vacío",
      "offlineSubtitle": "Reconéctate para cargar tu feed de noticias.",
      "emptyFeedSubtitle": "Agrega amigos para descubrir sus publicaciones, creaciones y presentaciones.\n\n¡Cuantos más amigos activos tengas, más animado será tu feed! 🎨"
    },
    "createPost": {
      "title": "Nueva publicación",
      "placeholder": "¿Qué hay de nuevo?",
      "videoReady": "Video listo",
      "photo": "Foto",
      "video": "Video",
      "publish": "Publicar"
    },
    "visibility": {
      "public": "Público",
      "friends": "Amigos",
      "pro": "PRO",
      "private": "Privado"
    },
    "postDetails": {
      "title": "📊 Detalles",
      "author": "Autor:",
      "published": "Publicado:",
      "reactions": "Reacciones:",
      "close": "Cerrar"
    }
  },
  "tabsLayout": {
    "offlineText": "Sin conexión a internet",
    "tabs": {
      "actu": "Feed",
      "games": "Juegos",
      "market": "Market",
      "messages": "Mensajes",
      "friends": "Amigos",
      "profile": "Perfil"
    }
  },
  "gamesScreen": {
    "header": {
      "pill": "Centro de Talentos",
      "title": "Revela tu Talento"
    },
    "infoBanner": {
      "title": "🏆 Harmonia — Centro de Talentos",
      "text": "Bienvenido a Harmonia, la plataforma que revela y celebra los talentos de nuestra comunidad. Participa en desafíos, enfréntate a tus amigos, muestra lo que sabes hacer — y gana trofeos entregados públicamente ante toda la comunidad. Cada semana, nuevos desafíos, nuevas disciplinas, nuevas oportunidades de brillar. Tu talento merece ser visto. Tu victoria merece ser celebrada. Únete al movimiento. Revela tu talento. Harmonia te espera. 🎯"
    },
    "chooseDiscipline": "ELIGE TU DISCIPLINA",
    "longPressHint": "Mantén presionado un juego para más detalles",
    "footerNote": "¡Nuevo contenido añadido cada semana — mantente conectado!",
    "trophiesAwardedPublicly": "Trofeos entregados públicamente ante la comunidad",
    "startAdventure": "Comenzar la aventura",
    "categories": {
      "strategie": {
        "title": "Juegos de Estrategia",
        "description": "Reflexión y táctica",
        "items": {
          "s1": {
            "title": "Awalé",
            "tagline": "El arte ancestral de la estrategia",
            "detail": "Domina el arte ancestral del Awalé y desafía a tus amigos en partidas estratégicas de rara intensidad. Cada semilla sembrada, cada captura decisiva te acerca a lo más alto de la clasificación. Los mejores tácticos de Harmonia verán su trofeo entregado públicamente ante toda la comunidad — porque la victoria merece consagrarse a la vista de todos."
          },
          "s2": {
            "title": "Damas",
            "tagline": "Domina el tablero, reina en el escenario",
            "detail": "Enfréntate a tus rivales en duelos de pura estrategia sobre el tablero. Anticipa cada movimiento, domina cada intercambio y captura para escalar en la clasificación de Harmonia. Los campeones son coronados públicamente — su trofeo, entregado ante toda la comunidad, es prueba de una excelencia que impone admiración."
          }
        }
      },
      "connaissance": {
        "title": "Juegos de Conocimientos",
        "description": "Pon a prueba tu saber",
        "items": {
          "c1": {
            "title": "Verdadero o Falso",
            "tagline": "Desafía a tus amigos con la verdad",
            "detail": "Pon a prueba tu conocimiento y desafía a tus amigos en duelos intelectuales tan emocionantes como impredecibles. Responde Verdadero o Falso con precisión y convicción, sube de nivel y escala en la clasificación de Harmonia. Tus trofeos se entregarán en público, ante toda la comunidad — porque el conocimiento, cuando está en la cima, merece su corona."
          }
        }
      },
      "arts": {
        "title": "Artes",
        "description": "Creatividad y expresión",
        "items": {
          "a1": {
            "title": "Fotografía",
            "tagline": "Tu mirada, tu firma",
            "detail": "La fotografía es una mirada al mundo que solo tú posees. Envía tus fotos más impactantes, hazte notar por la comunidad Harmonia y recibe trofeos entregados públicamente en homenaje a tu ojo artístico excepcional. En Harmonia, tu visión merece ser expuesta, admirada y celebrada en su justo valor."
          },
          "a2": {
            "title": "Dibujo",
            "tagline": "Tu trazo, tu universo",
            "detail": "Tu trazo es tu firma, tu estilo es tu identidad. Comparte tus dibujos con la comunidad Harmonia, conmueve a los espíritus y sé recompensado con trofeos entregados públicamente en reconocimiento a tu genio creativo. El arte solo vive gracias a quienes tienen el valor de mostrarlo — y Harmonia es tu escenario."
          },
          "a3": {
            "title": "Diseño",
            "tagline": "La estética al servicio de la intención",
            "detail": "El diseño es el encuentro entre la estética y la intención, entre la forma y el sentido. Expón tus creaciones visuales más audaces en Harmonia, inspira a tu comunidad y consigue trofeos entregados en público. Un gran diseñador merece un gran reconocimiento — y Harmonia te ofrece la tribuna que necesitas."
          }
        }
      },
      "performance": {
        "title": "Performance",
        "description": "Sube al escenario",
        "items": {
          "p1": {
            "title": "Comedia",
            "tagline": "La risa, el arte más universal",
            "detail": "La risa es el más universal y precioso de los talentos humanos. Sube al escenario de Harmonia, conmueve a la comunidad con tu humor, tu sentido del ritmo y tu presencia escénica incomparable. Los mejores comediantes verán sus trofeos entregados públicamente — porque hacer reír es un arte que merece ser honrado ante todos."
          },
          "p2": {
            "title": "Danza",
            "tagline": "Cada movimiento cuenta una historia",
            "detail": "Cada movimiento cuenta una historia que las palabras no pueden expresar. Comparte tu talento de bailarín con la comunidad Harmonia — gracia, potencia, creatividad, emoción — y consigue trofeos entregados en público, en homenaje a tu dominio absoluto del escenario. La danza es un lenguaje universal: Harmonia es tu podio."
          },
          "p3": {
            "title": "Teatro",
            "tagline": "Encarna, cautiva, trasciende",
            "detail": "El arte dramático es la expresión más profunda y justa del alma humana. Encarna a tus personajes con intensidad, cautiva a tu audiencia y haz de cada actuación un momento inolvidable. En Harmonia, los grandes actores de teatro son coronados públicamente — tu talento merece su luz, su ovación, su consagración."
          }
        }
      },
      "musique": {
        "title": "Música",
        "description": "Haz vibrar el escenario",
        "items": {
          "m1": {
            "title": "Canto",
            "tagline": "Tu voz, tu instrumento más preciado",
            "detail": "Tu voz es tu instrumento más preciado, tu timbre es tu huella en el mundo. Ya sea a capela pura o en interpretación acompañada, deja que tu voz resuene en toda la comunidad Harmonia. Los trofeos se entregan en público — porque las grandes voces merecen su ovación, su reconocimiento y su luz."
          },
          "m2": {
            "title": "Piano",
            "tagline": "88 teclas, un universo infinito",
            "detail": "Las 88 teclas del piano encierran un universo entero — desde la dulzura melancólica hasta las tormentas de pasión. Muestra tu virtuosismo, maravilla a la comunidad Harmonia con la riqueza de tu interpretación y recibe trofeos entregados públicamente en reconocimiento a tu dominio y tu sensibilidad musical excepcional."
          },
          "m3": {
            "title": "Guitarra",
            "tagline": "Cada acorde, una declaración",
            "detail": "Ya sea acústica, eléctrica o clásica, la guitarra tiene el poder de conmover almas y trascender fronteras. Comparte tus interpretaciones con la comunidad Harmonia — cada riff, cada solo, cada acorde te acerca a la cima. Corónate en ceremonias públicas de entrega de trofeos, ante todos."
          }
        }
      },
      "artisanat": {
        "title": "Artesanía",
        "description": "Saber hacer y oficios de excelencia",
        "items": {
          "ar1": {
            "title": "Costura",
            "tagline": "El arte que viste al mundo",
            "detail": "La costura es un arte milenario que viste al mundo con precisión y elegancia. Muestra tus creaciones, tu atención al detalle y tu dominio de la aguja a la comunidad Harmonia. Tus trofeos te serán entregados públicamente — porque la excelencia del oficio merece ser honrada, expuesta y celebrada ante todos."
          },
          "ar2": {
            "title": "Carpintería",
            "tagline": "La madera en tus manos se convierte en obra",
            "detail": "La madera en tus manos se convierte en arquitectura, belleza y utilidad. Comparte tus creaciones más destacadas con la comunidad Harmonia y recibe trofeos entregados en público, en homenaje a la nobleza de tu maestría artesanal. La carpintería es un arte exigente — Harmonia le rinde el honor que merece."
          },
          "ar3": {
            "title": "Peluquería",
            "tagline": "Sublimar, transformar, revelar",
            "detail": "La peluquería transforma, embellece y revela lo más hermoso que las personas llevan dentro. Presenta tus creaciones capilares más audaces a la comunidad Harmonia y consigue trofeos entregados públicamente — porque el arte de embellecer a otros es un don raro que merece su más bello y justo reconocimiento."
          },
          "ar4": {
            "title": "Soldadura",
            "tagline": "La precisión que une los metales",
            "detail": "La soldadura fusiona los metales, el ingenio y la precisión en un solo gesto dominado. Comparte tu experiencia técnica y tus creaciones más impresionantes con la comunidad Harmonia. Tus trofeos te serán entregados en público — el rigor, la precisión y la excelencia artesanal merecen su corona y reconocimiento."
          },
          "ar5": {
            "title": "Mecánica",
            "tagline": "La ciencia que hace girar el mundo",
            "detail": "La mecánica es la ciencia que literalmente hace girar el mundo. Demuestra tu experiencia, comparte tus trabajos técnicos más elaborados con la comunidad Harmonia y recibe trofeos entregados públicamente en homenaje a tu dominio excepcional de las máquinas, los motores y la ingeniería. La excelencia mecánica merece su podio."
          }
        }
      }
    }
  }
}
